import { createStore, applyMiddleware } from 'redux';
import RootReducer from './reducers/RootReducers';
import { composeWithDevTools } from 'redux-devtools-extension';

import thunk from 'redux-thunk';

const middlewares = [thunk];


const store = createStore(
  RootReducer,
  composeWithDevTools(applyMiddleware(...middlewares)),
);

export default store;